type HeliosFunctionOrderable = {
  id: string;
  order?: number | null;
};

export const sortHeliosFunctionsByOrder = <T extends HeliosFunctionOrderable>(
  functions: T[],
  getOrder?: (item: T) => number | null | undefined
): T[] => {
  return [...functions].sort((a, b) => {
    const orderA = getOrder?.(a) ?? a.order ?? Number.MAX_SAFE_INTEGER;
    const orderB = getOrder?.(b) ?? b.order ?? Number.MAX_SAFE_INTEGER;

    if (orderA !== orderB) {
      return orderA - orderB;
    }

    return a.id.localeCompare(b.id);
  });
};
